import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'

import { InputFirstRow } from './input-first-row'
import { InputSecondRow } from './input-second-row'
import { InputThirdRow } from './input-third-row'

import { projectInformationSelector } from '../../../../../../../selectors'

export const InputGroup = React.memo((props) => {
  const isEdit = useSelector(projectInformationSelector.getIsEditRevenuePlanning)

  return (
    <Root>
      <InputFirstRow { ...props } isEdit={ isEdit } />
      <InputSecondRow { ...props } isEdit={ isEdit } />
      <InputThirdRow { ...props } isEdit={ isEdit } />
    </Root>
  )
})

const Root = styled.div`
  padding: 0 24px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
`



// WEBPACK FOOTER //
// ./src/components/project-information/tab-content/tab-revenue-planning/revenue-table/item/project-detail/input-group.js